import {getNeutralPlayerMock} from "./getNeutralPlayerMock";

export const getPlayerById = (players, id) => {
  return players.find((player) => player.id === id) || getNeutralPlayerMock();
}